window.AiMatches = {
    init() {
        this.handleClickEvents();
        this.handleCheckboxChangeEvents();
        this.handleFocusEvents();
        this.handleShowAllEvents();
        this.handleRatingChangeEvents();
        this.handleStarChangeEvents();

        columnSelectCheckboxes.forEach((checkbox) => {
            const columnKey = checkbox.dataset.key;
            localStorage.removeItem(columnKey);

            const columnIndex = checkbox.dataset.index;
            checkbox.checked ? showColumn(columnIndex) : hideColumn(columnIndex);
        });

        updateContactSelectedButtonState();
    },

    copyNext10Urls() {
        const rows = Array.from(document.querySelectorAll('tr[data-ai-match-id]'));
        const unratedUrls = [];
        for (const row of rows) {
            if (unratedUrls.length >= 10) break;
            const id = row.dataset.aiMatchId;
            const ratingField = document.getElementById('rating-' + id);
            const rating = ratingField ? ratingField.value : '';
            if (rating === '' || rating === '0') {
                const url = row.dataset.websiteUrl;
                if (url) unratedUrls.push(url);
            }
        }
        if (unratedUrls.length === 0) return;
        navigator.clipboard.writeText(unratedUrls.join('\n')).then(() => {
            const btn = document.getElementById('copy-urls-btn');
            const original = btn.textContent;
            btn.textContent = `✓ Copied ${unratedUrls.length} URL${unratedUrls.length === 1 ? '' : 's'}`;
            setTimeout(() => { btn.textContent = original; }, 2000);
        });
    },

    handleClickEvents() {
        addToExtendedBtn.addEventListener('click', function () {
            const supplierList = document.getElementById('supplier-list');
            supplierList.replaceChildren();
            const ul = document.createElement('ul');
            ul.style.textAlign = 'left';
            selectedMatches.forEach(match => {
                const li = document.createElement('li');
                li.dataset.aiMatchId = String(match.id);

                const p = document.createElement('p');
                p.className = 'font-size-xs';
                p.textContent = match.name;

                li.appendChild(p);
                ul.appendChild(li);
            })

            supplierList.appendChild(ul);
            $("#create-extended-supplier-modal").modal("show");
        });

        contactSelectedBtn.addEventListener('click', function () {
            const selectedMatchIds = selectedMatches.map(match => match.id);
            contactSupplier(selectedMatchIds);
        });

        positiveSelectedBtn.addEventListener('click', function () {
            const selectedMatchIds = selectedMatches.map(match => match.id);
            updateRating(selectedMatchIds, 1);
        });

        negativeSelectedBtn.addEventListener('click', function () {
            const selectedMatchIds = selectedMatches.map(match => match.id);
            updateRating(selectedMatchIds, -1);
            matchesCheckboxes.forEach(function (checkbox) {
                checkbox.checked = false
            });
            selectAllMatchesCheckbox.checked = false;
            updateContactSelectedButtonState();
        });

        document.querySelectorAll("button[id^='positive-rate-match-']").forEach(button => {
            button.addEventListener("click", (event) => {
                const matchId = button.dataset.aiMatchId;
                updateRating([matchId], 1);
            });
        });

        document.querySelectorAll("button[id^='negative-rate-match-']").forEach(button => {
            button.addEventListener("click", (event) => {
                const matchId = button.dataset.aiMatchId;
                updateRating([matchId], -1);
            });
        });

        document.querySelectorAll("select[name='reject_reason']").forEach(select => {
            select.addEventListener("change", (event) => {
                let matchId = select.dataset.aiMatchId;
                let rejectReason = select.value;
                let tableRow = $(`tr[data-ai-match-id="${matchId}"]`)
                $.ajax({
                    url: MATCH_URL + matchId,
                    type: 'PATCH',
                    data: {data_system_deal_match: {reject_reason: rejectReason, rating: -1}},
                    success: function (data) {
                        tableRow.find('td:not(.checkbox)').each(function () {
                            $(this).css('background-color', negativeColor);
                        });
                        tableRow.find('input.email-select').parent().css('background-color', `${negativeColor}`);
                    }
                });
            });
        });
    },

    handleRatingChangeEvents() {
        positiveMatchHiddenField.addEventListener("change", updateMatchCount);
        negativeMatchHiddenField.addEventListener("change", updateMatchCount);

    },

    handleStarChangeEvents() {
        document.querySelectorAll('.ai-match-star').forEach(star => {
            star.addEventListener('click', function () {
                updateStar(this);
            });
        });
    },

    handleCheckboxChangeEvents() {
        selectAllMatchesCheckbox.addEventListener('change', function () {
            matchesCheckboxes.forEach(function (checkbox) {
                checkbox.checked = selectAllMatchesCheckbox.checked;
            });
            updateContactSelectedButtonState();
        });

        matchesCheckboxes.forEach(function (checkbox) {
            checkbox.addEventListener('change', function () {
                selectAllMatchesCheckbox.checked = Array.from(matchesCheckboxes).every(checkbox => checkbox.checked);
                updateContactSelectedButtonState();
            });
        });

        columnSelectCheckboxes.forEach((checkbox) => {
            const columnKey = checkbox.dataset.key;
            const columnIndex = checkbox.dataset.index;

            const savedState = localStorage.getItem(columnKey);
            if (savedState !== null) {
                const isChecked = savedState === 'true';
                checkbox.checked = isChecked;
                isChecked ? showColumn(columnIndex) : hideColumn(columnIndex);
            }

            checkbox.addEventListener('change', (event) => {
                const elm = event.currentTarget;
                const columnKey = elm.dataset.key;
                const columnIndex = elm.dataset.index;
                localStorage.setItem(columnKey, elm.checked);
                elm.checked ? showColumn(columnIndex) : hideColumn(columnIndex);
            });
        });
    },

    handleFocusEvents() {
        matchNotes.on('focusout', function () {
            const aiMatchId = $(this).data('ai-match-id');
            const notes = $(this).val();
            $.ajax({
                url: MATCH_URL + aiMatchId,
                type: 'PATCH',
                data: {data_system_deal_match: {notes: notes}}
            });
        });
    },

    handleShowAllEvents() {
        this.handleShowAll('emails');
        this.handleShowAll('phone-numbers');
        this.handleShowAll('products');
        this.handleShowAll('public-notes', 1);
        this.handleShowAll('private-notes', 1);
    },

    handleShowAll(listType, showAmount = 3) {
        const lists = document.querySelectorAll(`.${listType}-list`);
        const aiMatchIds = [];
        lists.forEach((list) => {
            if (list.dataset.aiMatchId) { // Check if the attribute exists
                aiMatchIds.push(list.dataset.aiMatchId);
            }
        });

        aiMatchIds.forEach(aiMatchId => {
            showAll(`show-all-${listType}-${aiMatchId}`, `${listType}-list-${aiMatchId}`, showAmount);
        });
    },

    openManualMatchModal() {
        $('#create-manual-match-modal').modal('show');
    }
};

const MATCH_URL = '/ai_matches/';
const matchNotes = $('.match-notes');

const positiveColor = 'rgba(128, 255, 128, 0.3)'; // 0.3 translates to "4d" opacity in hex
const negativeColor = 'rgba(255, 128, 128, 0.3)';

const selectAllMatchesCheckbox = document.getElementById('select-all-matches');
const matchesCheckboxes = document.querySelectorAll('input[type="checkbox"].match-select');
const columnSelectCheckboxes = document.querySelectorAll('input[type="checkbox"].column-select');
const contactSelectedBtn = document.getElementById('contact-matches-btn');
const positiveSelectedBtn = document.getElementById('positive-rate-matches-btn');
const negativeSelectedBtn = document.getElementById('negative-rate-matches-btn');
const addToExtendedBtn = document.getElementById('add-to-extended-btn');
const positiveMatchCountSpan = document.getElementById("positive-match-count");
const positiveMatchHiddenField = document.getElementById("positive-match-hidden");
const negativeMatchCountSpan = document.getElementById("negative-match-count");
const negativeMatchHiddenField = document.getElementById("negative-match-hidden");


let selectedMatches = [];

const updateRating = (aiMatchIds, rating) => {
    aiMatchIds.forEach(aiMatchId => {
        let tableRow = $(`tr[data-ai-match-id="${aiMatchId}"]`)

        const previousRating = document.getElementById(`rating-${aiMatchId}`).value;
        $.ajax({
            url: MATCH_URL + aiMatchId,
            type: 'PATCH',
            data: {data_system_deal_match: {rating: rating }},
            success: function (data) {
                if (rating === 1) {
                    tableRow.find('td:not(.checkbox)').each(function () {
                        $(this).css('background-color', positiveColor);
                    });
                    tableRow.find('input:checked.email-select').parent().css('background-color', `${positiveColor}`);
                    tableRow.find('input:checkbox:not(:checked).email-select').parent().css('background-color', `${negativeColor}`);

                    document.getElementById(`rating-${aiMatchId}`).value = rating;
                    if (previousRating === '0') {
                        positiveMatchHiddenField.value = parseInt(positiveMatchHiddenField.value) + 1;
                        const event = new Event("change");
                        positiveMatchHiddenField.dispatchEvent(event);
                    } else if (previousRating === '-1') {
                        positiveMatchHiddenField.value = parseInt(positiveMatchHiddenField.value) + 1;
                        negativeMatchHiddenField.value = parseInt(negativeMatchHiddenField.value) - 1;

                        const event = new Event("change");
                        positiveMatchHiddenField.dispatchEvent(event);
                        negativeMatchHiddenField.dispatchEvent(event);
                    }
                } else {
                    tableRow.find('td').each(function () {
                        $(this).css('background-color', negativeColor);
                    });
                    tableRow.find('input.email-select').parent().css('background-color', `${negativeColor}`);

                    document.getElementById(`rating-${aiMatchId}`).value = rating;
                    if (previousRating === '0') {
                        negativeMatchHiddenField.value = parseInt(negativeMatchHiddenField.value) + 1;
                        const event = new Event("change");
                        negativeMatchHiddenField.dispatchEvent(event);
                    } else if (previousRating === '1') {
                        positiveMatchHiddenField.value = parseInt(positiveMatchHiddenField.value) - 1;
                        negativeMatchHiddenField.value = parseInt(negativeMatchHiddenField.value) + 1;

                        const event = new Event("change");
                        positiveMatchHiddenField.dispatchEvent(event);
                        negativeMatchHiddenField.dispatchEvent(event);
                    }
                }
            }
        });
    })
};

// Rates a single email's entry within a match, without the checkbox-selection/table-row
// recoloring baggage `updateRating` carries — used by contexts that only know about one
// specific email (e.g. the Lusha contacts dialog in ai_matches/index.slim), not a checked
// set of rows/checkboxes.
const updateEmailRating = (aiMatchId, email, rating) => {
    return $.ajax({
        url: MATCH_URL + aiMatchId,
        type: 'PATCH',
        data: { data_system_deal_match: { rating: rating, emails: [email] } }
    });
};
window.AiMatches.updateEmailRating = updateEmailRating;

// Recolors an ai_match table row green and syncs its hidden rating field, to reflect a
// single email having been rated positive from elsewhere (e.g. the Lusha contacts dialog).
// Deliberately doesn't touch per-checkbox coloring or the positive/negative match counters —
// those track the bulk rate-selected-matches flow, not a one-off single-email rating.
const markMatchRowPositive = (aiMatchId) => {
    $(`tr[data-ai-match-id="${aiMatchId}"]`).find('td:not(.checkbox)').css('background-color', positiveColor);
    const ratingField = document.getElementById(`rating-${aiMatchId}`);
    if (ratingField) ratingField.value = 1;
};
window.AiMatches.markMatchRowPositive = markMatchRowPositive;

const updateMatchCount = () => {
    positiveMatchCountSpan.textContent = positiveMatchHiddenField.value;
    negativeMatchCountSpan.textContent = negativeMatchHiddenField.value;
};

const selectCheckedEmails = (tableRow, rating) => {
    let emails = [];
    if (rating === 1) {
        emails = tableRow.find('input:checked').map(function (_, el) {
            return $(el).val();
        }).get();
    } else {
        emails = tableRow.find("input[name='emails[]']").map(function (_, el) {
            return $(el).val();
        }).get();
    }
    return emails;
};

const contactSupplier = (aiMatchIds) => {
    $.ajax({
        url: MATCH_URL + 'contact_suppliers',
        type: 'POST',
        data: {
            data_system_deal_match_ids: aiMatchIds
        },
        success: function (data) {
            window.location.reload();
        },
        failure: function (error) {
            window.location.reload();
        }
    });
};

const updateContactSelectedButtonState = () => {
    let anyMatchSelected = false;
    selectedMatches = [];

    matchesCheckboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
            anyMatchSelected = true;
        }

        if (checkbox.checked && checkbox !== selectAllMatchesCheckbox) {
            const match = {"id": checkbox.dataset.aiMatchId, "name": checkbox.dataset.aiMatchName};
            selectedMatches.push(match);
        }
    });

    const selectedCountDesc = document.getElementById('selected-count-desc');
    selectedCountDesc.textContent = `${selectedMatches.length} of ${matchesCheckboxes.length}`;
    contactSelectedBtn.disabled = !anyMatchSelected;
    positiveSelectedBtn.disabled = !anyMatchSelected;
    negativeSelectedBtn.disabled = !anyMatchSelected;
    addToExtendedBtn.disabled = !anyMatchSelected;
}

const updateStar = (starElement) => {
    if (starElement) {
        const starred = starElement.dataset.starred === 'true';
        const newStarred = !starred;

        $.ajax({
            url: `/ai_matches/${starElement.dataset.aiMatchId}/star`,
            type: 'PUT',
            contentType: 'application/json',
            data: JSON.stringify({star: newStarred}),
            success: function () {
                starElement.dataset.starred = String(newStarred);
                starElement.style.opacity = newStarred ? '1.0' : '0.2';
            },
            error: function () {
                console.error('Failed to update star');
            }
        });
    }
};

function hideColumn(index) {
    $(`td:nth-child(${index}), th:nth-child(${index})`).hide();
}

function showColumn(index) {
    $(`td:nth-child(${index}), th:nth-child(${index})`).show();
}

// ── AI Outreach: schedule, cancel, status icon ──────────────────────────────

const AI_OUTREACH_URL = '/ai_outreach_schedules';

function initAiOutreach() {
    // Only wire up if admin outreach buttons exist on this page
    if (!document.querySelector('.ai-outreach-submit-btn')) return;

    document.querySelectorAll('.ai-outreach-submit-btn').forEach(btn => {
        btn.addEventListener('click', submitAiOutreachSchedule);
    });

    document.querySelectorAll('.ai-outreach-cancel-btn').forEach(btn => {
        btn.addEventListener('click', cancelAiOutreachSchedule);
    });

    document.querySelectorAll('.ai-outreach-call-now-submit-btn').forEach(btn => {
        btn.addEventListener('click', submitAiOutreachCallNow);
    });
}

function submitAiOutreachCallNow() {
    const btn        = this;
    const matchId    = btn.dataset.matchId;
    const scheduleId = btn.dataset.scheduleId;
    const modalId    = btn.dataset.modalId;
    const modal      = document.getElementById(modalId);
    if (!modal) return;
    const phoneInput = modal.querySelector('.ai-outreach-call-now-phone-input');
    const phone      = (phoneInput && phoneInput.value || '').trim();

    const errorsEl = document.getElementById(`call-now-errors-${matchId}`);
    if (errorsEl) { errorsEl.style.display = 'none'; errorsEl.innerHTML = ''; }

    if (!phone) {
        if (errorsEl) {
            errorsEl.innerHTML = '<ul><li>Phone number is required.</li></ul>';
            errorsEl.style.display = '';
        }
        return;
    }

    btn.disabled = true;

    const fd = new FormData();
    fd.append('phone_number', phone);

    fetch(`${AI_OUTREACH_URL}/${scheduleId}/dispatch_now`, {
        method:  'POST',
        headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'Accept':       'application/json'
        },
        body: fd
    })
        .then(r => r.json().then(data => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
            if (!ok || data.error || data.errors) {
                const msg = data.error || (data.errors && data.errors.join(', ')) || 'Dispatch failed.';
                if (errorsEl) {
                    errorsEl.innerHTML = `<ul><li>${msg}</li></ul>`;
                    errorsEl.style.display = '';
                }
                btn.disabled = false;
                return;
            }
            $(`#${modalId}`).modal('hide');
            // Reload — same reason as submitAiOutreachSchedule: dispatch flips
            // the schedule out of `dispatchable` so the action menu changes
            // (Call Now + Cancel both go away once status is in_progress).
            window.location.reload();
        })
        .catch(err => {
            console.error('AiOutreach dispatch_now error', err);
            if (errorsEl) {
                errorsEl.innerHTML = '<ul><li>Network error. Please try again.</li></ul>';
                errorsEl.style.display = '';
            }
            btn.disabled = false;
        });
}

function submitAiOutreachSchedule() {
    const btn     = this;
    const matchId = btn.dataset.matchId;
    const formId  = btn.dataset.formId;
    const form    = document.getElementById(formId);
    if (!form) return;

    const errorsEl = document.getElementById(`schedule-call-errors-${matchId}`);
    if (errorsEl) {
        errorsEl.style.display = 'none';
        errorsEl.innerHTML = '';
    }

    btn.disabled = true;

    fetch(AI_OUTREACH_URL, {
        method:  'POST',
        headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'Accept':       'application/json'
        },
        body: new FormData(form)
    })
        .then(r => r.json().then(data => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
            if (!ok || data.errors) {
                const errors = data.errors || ['An error occurred. Please try again.'];
                if (errorsEl) {
                    errorsEl.innerHTML = `<ul>${errors.map(e => `<li>${e}</li>`).join('')}</ul>`;
                    errorsEl.style.display = '';
                }
                btn.disabled = false;
                return;
            }
            // Close modal first so reload doesn't flash a stale-state modal.
            $(`#schedule-call-modal-${matchId}`).modal('hide');
            // Full reload — the row's action menu + the dialog partials are
            // all conditional on schedule state (cancel/call-now/etc.); a
            // partial icon-swap leaves the menu out of sync (e.g. Call Now
            // (test) was missing until manual refresh, observed 2026-06-12).
            window.location.reload();
        })
        .catch(err => {
            console.error('AiOutreach schedule error', err);
            btn.disabled = false;
        });
}

function cancelAiOutreachSchedule(e) {
    e.preventDefault();
    const btn        = this;
    const confirmMsg = btn.dataset.aiConfirm;
    if (confirmMsg && !window.confirm(confirmMsg)) return;

    const scheduleId = btn.dataset.scheduleId;

    fetch(`${AI_OUTREACH_URL}/${scheduleId}`, {
        method:  'DELETE',
        headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'Accept':       'application/json'
        }
    })
        .then(() => window.location.reload())
        .catch(err => console.error('AiOutreach cancel error', err));
}

// Event delegation: discard call result
document.addEventListener('click', function (e) {
    const btn = e.target.closest('.ai-outreach-discard-btn');
    if (!btn) return;
    e.preventDefault();

    const confirmMsg = btn.dataset.aiConfirm;
    if (confirmMsg && !window.confirm(confirmMsg)) return;

    const scheduleId = btn.dataset.scheduleId;
    const matchId    = btn.dataset.matchId;

    fetch(`${AI_OUTREACH_URL}/${scheduleId}/discard`, {
        method:  'PATCH',
        headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'Accept':       'application/json'
        }
    })
        .then(r => r.json())
        .then(data => {
            if (data.discarded) {
                // Clear the status icon from the table row
                const iconSpan = document.getElementById(`ai-outreach-icon-${matchId}`);
                if (iconSpan) iconSpan.innerHTML = '';
                // Close any open modal
                const resultContainer = document.getElementById(`ai-outreach-result-container-${matchId}`);
                if (resultContainer) {
                    const modalEl = resultContainer.querySelector('.modal');
                    if (modalEl) $(modalEl).modal('hide');
                    resultContainer.innerHTML = '';
                }
            }
        })
        .catch(err => console.error('AiOutreach discard error', err));
});

// Event delegation: save outcome override
document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[data-schedule-id]');
    if (!form || !form.action || !form.action.includes('update_outcome')) return;
    e.preventDefault();

    const scheduleId = form.dataset.scheduleId;
    const errorsEl   = document.getElementById(`outcome-errors-${scheduleId}`);
    if (errorsEl) { errorsEl.style.display = 'none'; errorsEl.innerHTML = ''; }

    fetch(form.action, {
        method:  'PATCH',
        headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'Accept':       'application/json'
        },
        body: new FormData(form)
    })
        .then(r => r.json().then(data => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
            if (!ok || data.errors) {
                const errors = data.errors || ['Failed to save.'];
                if (errorsEl) {
                    errorsEl.innerHTML = `<ul>${errors.map(e => `<li>${e}</li>`).join('')}</ul>`;
                    errorsEl.style.display = '';
                }
            }
        })
        .catch(err => console.error('AiOutreach update_outcome error', err));
});

// Event delegation: status icon clicks (works on icons added dynamically after scheduling)
document.addEventListener('click', function (e) {
    const link = e.target.closest('.ai-outreach-status-icon');
    if (!link) return;
    e.preventDefault();

    const scheduleId = link.dataset.scheduleId;
    const matchId    = link.dataset.matchId;

    fetch(`${AI_OUTREACH_URL}/${scheduleId}`, {
        headers: { 'Accept': 'text/html, */*' }
    })
        .then(r => r.text())
        .then(html => {
            const container = document.getElementById(`ai-outreach-result-container-${matchId}`);
            if (!container) return;
            container.innerHTML = html;
            const modalEl = container.querySelector('.modal');
            if (modalEl) $(modalEl).modal('show');
        })
        .catch(err => console.error('AiOutreach status icon click error', err));
});

// Transcript show/hide toggle inside the result dialog. Delegated because the
// dialog HTML is injected via innerHTML, so inline <script> in the partial
// would never execute.
document.addEventListener('click', function (e) {
    const toggle = e.target.closest('.ai-outreach-transcript-toggle');
    if (!toggle) return;
    e.preventDefault();
    const pre = toggle.nextElementSibling;
    if (pre) pre.style.display = pre.style.display === 'none' ? 'block' : 'none';
});

document.addEventListener('DOMContentLoaded', initAiOutreach);

// ── End AI Outreach ──────────────────────────────────────────────────────────

function showAll(showAllId, listId, showAmount = 3) {
    const showAllBtn = document.getElementById(showAllId);
    const elementList = document.getElementById(listId);

    if (elementList) {
        Array.from(elementList.children).forEach((item, index) => {
            if (index > showAmount - 1) {
                item.style.display = 'none';
            } else {
                item.style.display = 'block';
            }
        });

        if (showAllBtn) {
            showAllBtn.dataset.showingAll = "false";
            showAllBtn.addEventListener('click', () => {
                const isShowingAll = showAllBtn.dataset.showingAll === "true";

                if (isShowingAll) {
                    Array.from(elementList.children).forEach((item, index) => {
                        if (index > showAmount - 1) {
                            item.style.display = 'none';
                        } else {
                            item.style.display = 'block';
                        }
                    });

                    showAllBtn.textContent = 'Show all';
                    showAllBtn.dataset.showingAll = "false";
                } else {
                    Array.from(elementList.children).forEach((item) => {
                        item.style.display = 'block';
                    });

                    showAllBtn.textContent = 'Show less';
                    showAllBtn.dataset.showingAll = "true";
                }
            });
        }
    }
}
